import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  WPFModel,
  factorsObj,
  WinFactorsModel,
  WPFProjectModel,
} from "../../models/WinProbabilityFactorModel";

const initialState: WPFModel = {
  goFactors: {},
  getFactors: {},
  questions: {
    getFactorQuestions: [],
    goFactorQuestions: [],
  },
  projectQuestions: {
    goFactorSelectedOptions: [],
    getFactorSelectedOptions: [],
  },
};

const WPFSlice = createSlice({
  name: "WPF",
  initialState: initialState,
  reducers: {
    setQuestions: (state, action: PayloadAction<WinFactorsModel>) => {
      state.questions = action.payload;
    },
    setGoFactors: (state, action: PayloadAction<factorsObj>) => {
      state.goFactors = action.payload;
    },
    setGetFactors: (state, action: PayloadAction<factorsObj>) => {
      state.getFactors = action.payload;
    },
    setProjectQuestions: (state, action: PayloadAction<WPFProjectModel>) => {
      state.projectQuestions = action.payload;
    },
  },
});

export default WPFSlice;
